function generateTree(files) {
    const tree = [];
    files.forEach((file) => {
      const parts = file.path.split('/').filter((part) => part && part !== '.');
      let current = tree;
  
      parts.forEach((part, index) => {
        const existing = current.find((item) => item.name === part);
        if (existing) {
          current = existing.children || [];
        } else {
          const newNode = {
            name: part.replace('.md', ''),
            // 只有非最后一个部分（文件夹）才有 children
            ...(index === parts.length - 1 
              ? { path: file.path }  // 文件节点
              : { children: [] }     // 文件夹节点
            )
          };
          current.push(newNode);
          current = newNode.children || [];
        }
      });
    });
    return tree;
}
  
export default generateTree;